import { VaultsDiscover } from '@/components/discoverOpportunities/vaultsDiscover'
import { Page } from '@/components/layout/wrappers'
import { queryClient } from '@/config/query/queryClient'
import { APP_META_DESCRIPTION, APP_META_TITLE } from '@/constants/meta'
import { vaultsQueryOptions } from '@/queries/vaults.query'
import { getMetaTags } from '@/utils/meta/getMetaTags'
import type { MetaFunction } from 'react-router'
import { useLoaderData } from 'react-router'

export const loader = async () => {
  const initialVaultsData = await queryClient.ensureQueryData(vaultsQueryOptions())

  return { initialVaultsData }
}

export const shouldRevalidate = ({
  currentUrl,
  nextUrl,
  defaultShouldRevalidate,
}: {
  currentUrl: URL
  nextUrl: URL
  defaultShouldRevalidate: boolean
}) => {
  if (currentUrl.pathname === nextUrl.pathname) {
    return false
  }

  return defaultShouldRevalidate
}

export type DiscoverLoader = typeof loader

export const meta: MetaFunction = ({ location }) => {
  return getMetaTags({
    title: APP_META_TITLE,
    description: APP_META_DESCRIPTION,
    url: location.pathname,
  })
}

export default function Index() {
  const { initialVaultsData } = useLoaderData<DiscoverLoader>()

  return (
    <Page>
      <VaultsDiscover initialData={initialVaultsData} />
    </Page>
  )
}
